const bundle = {
  close: () => 'Lukk',
  error: () => 'Feil',
  warn: () => 'Advarsel',
  info: () => 'Opplysninger',
  confirmation: () => 'Bekreftelse',
  progressIndeterminate: () => 'Pågår',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellom ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Finner ingen samsvarende seksjon.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Trykk på Enter hvis du vil velge verdien.',
  indexer_touchInstructionText: () =>
    'Dobbelttrykk og hold, slik at bevegelsesmodus aktiveres, og dra deretter opp og ned hvis du vil justere verdien.',
  inputPassword_show: () => 'Vis passord',
  inputPassword_hide: () => 'Skjul passord',
  inputPassword_hidden: () => 'Passord skjult',
  formControl_clear: () => 'Nullstill',
  formControl_loading: () => 'Laster',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumslengden, ' + p['MAX_LENGTH'] + ', er overskredet.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tegn igjen.',
  select_noMatchesFound: () => 'Ingen samsvar funnet.',
  select_oneMatchFound: () => 'Finner ett treff',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' samsvar funnet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eller flere samsvar funnet',
  selectMultiple_showSelectedValues: () => 'Vis bare valgte verdier.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' verdier er valgt.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Avmerket',
  selector_unselected: () => 'Ikke avmerket',
  userAssistance_learnMore: () => 'Jeg vil vite mer',
  userAssistance_required: () => 'Nødvendig',
  filePicker_singleFileUploadError: () => 'Last én fil om gangen',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan ikke laste filer av typen ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan ikke laste filer av følgende typer: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'ukjent',
  filePicker_dropzonePrimaryText: () => 'Dra og slipp',
  filePicker_dropzoneSecondaryText: () => 'Velg en fil, eller slipp en fil her',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Velg eller slipp filer her',
  filePicker_addFiles: () => 'Legg til filer',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Øk',
  inputNumber_decrease: () => 'Reduser',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Ingen elementer å vise',
  message_navigationFromMessagesRegion: () =>
    'Åpner meldingsområde. Trykk på F6 hvis du vil navigere tilbake til tidligere fokusert element.',
  message_navigationToMessagesRegion: () =>
    'Meldingsområdet inneholder nye meldinger. Trykk på F6 hvis du vil navigere til de nyeste meldingene.',
  messageToast_allMessagesClosed: () => 'Alle sprettoppvarsler er lukket.'
};
export default bundle;
